<template>
  <page-header>
    <h2>Руководство пользователя</h2>    
  </page-header>

  <section class="content">
    <template v-if="items.length">  
      <div class="manual__item" v-for="(item, index) of items" :key="index">        
        <p class="manual__item_title"><a href="javascript:" class="custom-title btn" @click.prevent="downloadFile(item)">{{item.name}} <i class="fa fa-download"></i></a></p>
        <p class="date">{{ $momentFormat(item.created, "DD MMMM YYYY") }}, {{ item.file.originalName.split('.').pop() }}, {{ (item.file.fileSize / 1024).toFixed(1) }} КБ</p>
        <p class="manual__item_text">{{item.description}}</p>
      </div>
    </template>
    <template v-if="false">
      <EmptyListMessage/>
    </template>
    <!-- <div class="card">
      <file-multi-upload
        :entity="item"
        prop-name="files"
        :readonly="true"
      />
    </div>     -->
  </section>
</template>
<script>
import API from '@/modules/settings/api/manual';
import PageHeader from "@/common/components/page/PageHeader";
import FileAPI from "@/modules/file/api";

export default {
  name: "ManualPublic",
  components: {
    PageHeader
  },
  data() {
    return {
      items: [],   
    }
  },
  created() {    
    this.loadPage();
  },
  methods: {
    loadPage() {
      API.search().then((response) => {
        this.items = response.data;
      });
    },  
    downloadFile(item) {
      FileAPI.download(item.fileId)
        .then(response => {
            const blob = new Blob([response.data], {type: item.file.contentType});
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = item.file.originalName;
            link.click();
            URL.revokeObjectURL(link.href);
        });
    }  
  }
}
</script>
<style lang="scss" scoped>
@import '/src/assets/theme/default/colors.scss';

.content {
  padding: 32px;
  position: relative;
  overflow-y: visible;
}

.date{
  font-weight: 300;
  font-size: 12px;
  line-height: 200%;
  color: #969595;
  margin-bottom: 8px;
}
.manual__item{
  cursor: pointer;
  width: 100%;  
  margin-bottom: 40px;
  &_title {
    margin-bottom: 0;
  }
}
.custom-title{
  height: auto;
  margin-bottom: 0px;
  color: #000;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 700;
  font-size: 1.2rem;
  line-height: 24px;
  text-decoration: none;
  padding: 6px 0;
}

.btn {
  display: inline-block;
}
.btn:focus{
    box-shadow: none !important;
    outline: none !important;
}

.fa-download{
    color: $blue-light
}
</style>